import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class BannerCollapseService {

  private _changes$ = new Subject<string>();
  private _modifyDateCache = new Map<string, string>();

  public changes$ = this._changes$.asObservable();

  public isCollapsed(type: string): boolean {
    return localStorage.getItem(`tuio_banner_collapsed_${type}`) === 'true';
  }

  public isBannerActive(type: string): boolean {
    return localStorage.getItem(`tuio_banner_active_${type}`) === 'true';
  }

  public handleBannerUpdate(type: string, modifyDate: unknown, enabled: boolean | number | null): void {
    localStorage.setItem(`tuio_banner_active_${type}`, String(!!enabled));

    const currentVersion = this._normalizeDate(modifyDate);
    this._modifyDateCache.set(type, currentVersion);

    // Only check for change if the user has previously collapsed this banner.
    // This avoids false positives from date format inconsistencies on first load.
    const dismissedVersion = localStorage.getItem(`tuio_banner_dismissed_version_${type}`);
    if (dismissedVersion !== null && dismissedVersion !== currentVersion) {
      localStorage.removeItem(`tuio_banner_collapsed_${type}`);
      localStorage.removeItem(`tuio_banner_dismissed_version_${type}`);
    }

    this._changes$.next(type);
  }

  public toggle(type: string): void {
    const newCollapsed = !this.isCollapsed(type);
    localStorage.setItem(`tuio_banner_collapsed_${type}`, String(newCollapsed));

    if (newCollapsed) {
      // Snapshot the current banner version so we can detect future changes
      localStorage.setItem(`tuio_banner_dismissed_version_${type}`, this._modifyDateCache.get(type) ?? '');
    } else {
      localStorage.removeItem(`tuio_banner_dismissed_version_${type}`);
    }

    this._changes$.next(type);
  }

  private _normalizeDate(d: unknown): string {
    if (d == null) return '';
    const ts = new Date(String(d)).getTime();
    return isNaN(ts) ? String(d) : String(ts);
  }

}
